export const DEFAULT_COMPETITION_TYPE = 'MATHS_TALENTS';
export const EXAM_LEVEL_TYPE = [{
    id: 'MATHS_TALENTS_1',
    label: '丘成桐少年班',
}, {
  id: 'MATHS_TALENTS_2',
  label: '丘成桐少年班选拔',
  },
  {
    id: 'MATHS_TALENTS_3',
    label: '丘成桐少年班初一选拔',
  },
  {
    id: 'MATHS_TALENTS_4',
    label: '5-6年级',
  },
];
export const EXAM_LEVEL_TYPE_ENUM = {
    MATHS_TALENTS_1: '丘成桐少年班',
    MATHS_TALENTS_2: '丘成桐少年班选拔',
    MATHS_TALENTS_3: '丘成桐少年班初一选拔',
    MATHS_TALENTS_4: '5-6年级',
}
export const QuestionTypeMap = {
  'TEXT_CHOICE_QUESTION':'单选题',
  'TEXT_MULTI_CHOICE': '多选题',
  'BLANK_FILLING': '填空题',
  'PICTURE_BLANK_FILLING': '填空题',
  'PICTURE_PROOF': '问答题',
}
export const ROLE_MAP = {
    'ADMIN':'管理员',
    'TEACHER':'老师',
    'STUDENT':'学生',
}

export const CHECK_STATUS_MAP = {
  0:{
    label:'待批改',
    style:'un-check'
  },
  1: {
    label:'批改中',
    style:'checking'
  },
  2:{
    label:'成绩已核对',
    style:'checked'
  },
  3:{
      label:'清华已复核',
      style:'rechecked'
  }
}

export const USER_GRADE_MAP = [
    { label: '小学前', value: '小学前' },
    { label: '小学', value: '小学' },
    { label: '初一', value: '初一' },
    { label: '初二', value: '初二' },
    { label: '初三', value: '初三' },
    { label: '高一', value: '高一' },
    { label: '高二', value: '高二' },
    { label: '高三', value: '高三' },
    { label: '大学及以上', value: '大学及以上' },
]

// 二级年级选择器数据（用于级联选择）
export const USER_GRADE_CASCADE = [
  {
    text: '小学前',
    value: 'pre_primary',
    children: [{ text: '小学前', value: '小学前' }]
  },
  {
    text: '小学',
    value: 'primary',
    children: [
      { text: '一年级', value: '一年级' },
      { text: '二年级', value: '二年级' },
      { text: '三年级', value: '三年级' },
      { text: '四年级', value: '四年级' },
      { text: '五年级', value: '五年级' },
      { text: '六年级', value: '六年级' }
    ]
  },
  {
    text: '初中',
    value: 'middle',
    children: [
      { text: '初一', value: '初一' },
      { text: '初二', value: '初二' },
      { text: '初三', value: '初三' }
    ]
  },
  {
    text: '高中',
    value: 'high',
    children: [
      { text: '高一', value: '高一' },
      { text: '高二', value: '高二' },
      { text: '高三', value: '高三' }
    ]
  },
  {
    text: '大学及以上',
    value: 'university',
    children: [{ text: '大学及以上', value: '大学及以上' }]
  }
]

export const CheatTypeList = [
  { label: '疑似离开了', value: 'scenePersonExit' },
  { label: '画面疑似有多个人', value: 'manyPeople' },
  { label: '疑似起立', value: 'actionPoseStandup' },
  { label: '疑似频繁点头', value: 'headUpDown' },
  { label: '疑似频繁转头/摇头', value: 'headShaking' },
  { label: '疑似戴手表', value: 'watch' },
  { label: '疑似戴耳机', value: 'earPhone' },
  { label: '疑似打电话', value: 'cellPhone' },
  { label: '疑似现场有人说话', value: 'actionPersonSpeech' },
  { label: '疑似举手', value: 'actionPoseHandup' },
  // 新增页面状态检测类型
  { label: '疑似切换页面', value: 'pageHidden'},
  { label: '疑似页面失焦', value: 'pageBlur'},
  { label: '疑似鼠标离开', value: 'mouseLeave'},

]